export const STRIPE_KEY = 'STRIPE_KEY';
export const ACTIVATION_FEE = 'ACTIVATION_FEE';
export const PAYMENT_LOADER = 'PAYMENT_LOADER';
export const SET_APPEAL_CATEGORIES = 'SET_APPEAL_CATEGORIES';
export const SET_VETTING_SETTINGS = 'SET_VETTING_SETTINGS';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_BRAND_IDENTITY_STATUS = 'SET_BRAND_IDENTITY_STATUS';
export const SET_LOA_STATUS = 'SET_LOA_STATUS';
export const SET_STOCK_EXCHANGES = 'SET_STOCK_EXCHANGES';
export const SET_TRADEMARK_VERIFICATION_STATUS =
  'SET_TRADEMARK_VERIFICATION_STATUS';
export const SET_VERTICAL_TYPES = 'SET_VERTICAL_TYPES';
export const SET_DCAS = 'SET_DCAS';
export const SET_PATENT_OFFICES = 'SET_PATENT_OFFICES';
